import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { PaleteEnum } from "../../../interfaces/Enums";
import { IPinSchema } from "../../../interfaces/IPin";
import { usePinPost } from "../../../queries/Pin/post";
import { useAuthentication } from "../../../store/Authentication";
import {
  PinMaskCustom,
  defaultValuesPinInactive,
  pinInactiveSchema,
} from "./validations";

export default function PinInactive() {
  const { profile } = useAuthentication();
  const { request } = usePinPost();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IPinSchema>({
    defaultValues: defaultValuesPinInactive,
    resolver: yupResolver(pinInactiveSchema.required()),
  });

  function onSubmit(data: IPinSchema) {
    const dataUnMask = data.numeroPin.replace(/-/g, "");
    request({
      numeroPin: dataUnMask,
      tipoPin: data.tipoPin,
    });
    reset(defaultValuesPinInactive);
  }

  return (
    <Grid
      container
      flexDirection={"column"}
      alignItems={"center"}
      justifyItems={"center"}
      p={4}
      pt={{ md: 10 }}
    >
      <Grid item container width={{ md: "50%", lg: "35%" }} rowSpacing={2}>
        <Grid item container flexDirection={"column"}>
          <Typography variant="h6" align="center">
            Bem vindo <strong>{profile.nome}!</strong>
          </Typography>
          <Typography variant="body1" mt={4}>
            Falta apenas um pequeno passo para você começar a aproveitar seu NBA
            Team Pass.
          </Typography>
          <Typography variant="body1" mt={1}>
            Por favor, insira o Código | PIN para desbloquear sua conta!
          </Typography>
        </Grid>
        <Grid item container rowSpacing={2}>
          <Grid item container>
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="PIN"
              placeholder="Insira um PIN"
              fullWidth
              error={!!errors["numeroPin"]}
              InputProps={{
                inputComponent: PinMaskCustom as any,
              }}
              {...register("numeroPin")}
            />
            <Typography variant="caption" mt={0.5} color={"red"}>
              {errors.numeroPin?.message}
            </Typography>
          </Grid>
          <Grid item container>
            <Button
              type="submit"
              variant={"contained"}
              sx={{
                bgcolor: PaleteEnum.bluePrimary,
                "&:hover": { bgcolor: PaleteEnum.bluePrimary },
              }}
              onClick={handleSubmit(onSubmit)}
              fullWidth
            >
              Resgatar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
